var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14010_1322)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14010_1322",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 10.0003C18.3333 14.6027 14.6023 18.3337 10 18.3337C5.39763 18.3337 1.66667 14.6027 1.66667 10.0003C1.66667 5.39795 5.39763 1.66699 10 1.66699C14.6023 1.66699 18.3333 5.39795 18.3333 10.0003ZM8.97726 11.2557C8.97967 10.8352 9.01351 10.7203 9.07876 10.4985C9.08584 10.4744 9.09334 10.4491 9.10109 10.4219C9.18367 10.1449 9.30351 9.92124 9.46067 9.75074C9.61784 9.58033 9.80692 9.42583 10.028 9.28733C10.1931 9.18083 10.3409 9.07024 10.4714 8.95574C10.6019 8.84124 10.7058 8.71474 10.783 8.57624C10.8603 8.43508 10.8989 8.27793 10.8989 8.10482C10.8989 7.92104 10.8549 7.75991 10.7671 7.62142C10.6792 7.48293 10.5607 7.37639 10.4115 7.30182C10.265 7.22724 10.1025 7.18996 9.92409 7.18996C9.75101 7.18996 9.58717 7.22858 9.43267 7.30581C9.27825 7.38038 9.15176 7.49224 9.05317 7.64139C8.95467 7.78788 8.90134 7.97032 8.89342 8.18871H7.26341C7.27673 7.65604 7.40457 7.21659 7.64693 6.87035C7.8893 6.52145 8.21023 6.26178 8.60976 6.09133C9.00926 5.9182 9.45001 5.83164 9.93209 5.83164C10.4621 5.83164 10.9308 5.91953 11.3383 6.09532C11.7458 6.26843 12.0654 6.52013 12.2972 6.85038C12.5288 7.18063 12.6448 7.57881 12.6448 8.04489C12.6448 8.35649 12.5928 8.63349 12.4889 8.87583C12.3877 9.11558 12.2452 9.32866 12.0614 9.51508C11.8777 9.69883 11.6606 9.86533 11.4103 10.0144C11.1998 10.1397 11.0268 10.2702 10.8909 10.406C10.7578 10.5418 10.6578 10.6989 10.5913 10.8774C10.5273 11.0558 10.4914 11.2557 10.4914 11.2557H8.97726ZM9.76826 14.2292C9.50192 14.2292 9.27426 14.136 9.08517 13.9496C8.89867 13.7604 8.80684 13.5341 8.8095 13.2704C8.80684 13.0094 8.89867 12.7857 9.08517 12.5992C9.27426 12.4128 9.50192 12.3196 9.76826 12.3196C10.0213 12.3196 10.2437 12.4128 10.4355 12.5992C10.6273 12.7857 10.7244 13.0094 10.7271 13.2704C10.7244 13.4462 10.6778 13.6073 10.5873 13.7538C10.4994 13.8976 10.3835 14.0135 10.2397 14.1013C10.0959 14.1866 9.93876 14.2292 9.76826 14.2292Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14010_1322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#6C6C6C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14010_1322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.fd751ddb094ee9cdf766969205f5096d.svg";
export { ForwardRef as ReactComponent };